import {
  POPULATE_FLEETS,
  SET_ACTIVE_FLEET,
  SET_ACTIVE_VEHICLE,
  SET_EVENTS_MAP,
  SET_FLEET_VEHICLES,
  SET_FLEET_VEHICLES_WITH_COMPONENTS,
  SET_GEOFENCES,
  SET_TRIPS,
  SET_ACTIVE_SIM_CONFIG,
  SET_MIN_TIMELINE_DATE,
  SET_MAX_TIMELINE_DATE,
  SET_VEHICLE_TIMELINE_STATUSES,
  PATCH_ACTIVE_VEHICLE,
} from "../types";

export default (state, action) => {
  switch (action.type) {
    case POPULATE_FLEETS:
      return {
        ...state,
        fleets: action.payload,
      };
    case SET_ACTIVE_FLEET:
      if (action.payload?.uuid4)
        localStorage.setItem("activeFleetUUID4", JSON.stringify(action.payload?.uuid4));
      return {
        ...state,
        activeFleet: action.payload,
      };
    case SET_ACTIVE_VEHICLE:
      return {
        ...state,
        activeVehicle: action.payload,
      };
    case PATCH_ACTIVE_VEHICLE:
      return {
        ...state,
        activeVehicle: {...state.activeVehicle, ...action.payload},
      };
    case SET_ACTIVE_SIM_CONFIG:
      return {
        ...state,
        activeSIMConfig: action.payload,
      };
    case SET_FLEET_VEHICLES:
      return {
        ...state,
        fleetVehicles: action.payload,
      };
    case SET_FLEET_VEHICLES_WITH_COMPONENTS:
      return {
        ...state,
        fleetVehiclesWithComponents: action.payload,
      };
    case SET_TRIPS:
      return {
        ...state,
        trips: action.payload,
      };
    case SET_GEOFENCES:
      return {
        ...state,
        geofences: action.payload,
      };
    case SET_EVENTS_MAP:
      return {
        ...state,
        eventsMap: action.payload,
      };
    case SET_MIN_TIMELINE_DATE:
      return {
        ...state,
        minTimelineDate: action.payload,
      };
    case SET_MAX_TIMELINE_DATE:
      return {
        ...state,
        maxTimelineDate: action.payload,
      };
    case SET_VEHICLE_TIMELINE_STATUSES:
      return {
        ...state,
        vehicleTimelineStatuses: action.payload,
      };
    default:
      return state;
  }
};
